module.exports = __webpack_public_path__ + "img/3.247334b8.webp";